import { Link } from 'react-router-dom';
import Section from '../components/Section';
import Arrow from '../components/Arrow';

export default function NotFound() {
  return (
    <Section title="Page not found" lead="That page doesn't exist - or hasn't been built yet.">
      <Link to="/" className="btn btn--primary">
        <Arrow left className="btn__arrow btn__arrow--back" /> Back home
      </Link>
    </Section>
  );
}
